if (location.href.indexOf('search?') == -1 && $('.second-collection__description').length) {
    const collectionDescriptionElement = $('.collection__description').closest('.container');
    const collectionDescriptionElement2 = $('.second-collection__description > div');
    const collectionDescriptionHTML = collectionDescriptionElement[0].innerHTML;
    const collectionDescription2HTML = collectionDescriptionElement2[0].innerHTML;
    if (location.href.indexOf('page=') > 0) {
        collectionDescriptionElement.html('');
        $('.second-collection__description > div').html('');
    }
    $(document).on('click', '.boost-pfs-filter-bottom-pagination nav.pagination a', () => {
        if (location.href.indexOf('page=') == -1) {
            collectionDescriptionElement.html(collectionDescriptionHTML);
            $('.second-collection__description > div').html(collectionDescription2HTML);
        } else {
            collectionDescriptionElement.html('');
            $('.second-collection__description > div').html('');
        }
    });
    const moreDescriptionContinue = Shopify.translation.desc_continue;
    const moreDescriptionHidden = Shopify.translation.desc_hidden;
    $(document).on('click', '#show-more-description', () => {
        if ($('#show-more-description').text() == moreDescriptionContinue) {
            $('#show-more-description').text(moreDescriptionHidden);
            $('#show-more-description').before(collectionDescription2HTML);
            collectionDescriptionElement.find('.has-padding-bottom').css('padding-bottom', 0);
            collectionDescriptionElement.find('.has-padding-bottom .collection__description').css('padding-bottom', 0);
            $('.second-collection__description > div').html('');
        }
        else {
            $('#show-more-description').text(moreDescriptionContinue);
            collectionDescriptionElement.html(collectionDescriptionHTML);
            collectionDescriptionElement.find('.collection__description').removeAttr('style');
            $('.second-collection__description > div').html(collectionDescription2HTML);
            $(window).scrollTop(0);
        }

        return false;
    });
}